import { render, staticRenderFns } from "./RankingsOverviewPage.vue?vue&type=template&id=4097e0c4&scoped=true&"
import script from "./RankingsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./RankingsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./RankingsOverviewPage.vue?vue&type=style&index=0&id=4097e0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4097e0c4",
  null
  
)

export default component.exports